import type { KanbanCardRecurrence } from 'types/kanban';

export type RecurrencePresetId =
  'none' | 'daily' | 'weekly' | 'biweekly' | 'monthly' | 'yearly';

export function recurrenceToPreset(
  rule: KanbanCardRecurrence | null | undefined,
): RecurrencePresetId {
  if (!rule) return 'none';
  const { frequency, interval } = rule;
  const n = interval ?? 1;
  if (frequency === 'daily' && n === 1) return 'daily';
  if (frequency === 'weekly' && n === 1) return 'weekly';
  if (frequency === 'weekly' && n === 2) return 'biweekly';
  if (frequency === 'monthly' && n === 1) return 'monthly';
  if (frequency === 'yearly' && n === 1) return 'yearly';
  return 'none';
}

export function presetToRecurrence(
  preset: RecurrencePresetId,
): KanbanCardRecurrence | null {
  if (preset === 'none') return null;
  switch (preset) {
    case 'daily':
      return { frequency: 'daily', interval: 1 };
    case 'weekly':
      return { frequency: 'weekly', interval: 1 };
    case 'biweekly':
      return { frequency: 'weekly', interval: 2 };
    case 'monthly':
      return { frequency: 'monthly', interval: 1 };
    case 'yearly':
      return { frequency: 'yearly', interval: 1 };
    default:
      return null;
  }
}

export function formatRecurrenceLabel(
  rule: KanbanCardRecurrence | null | undefined,
): string {
  if (!rule) return '';
  const { frequency, interval } = rule;
  const n = interval ?? 1;
  if (frequency === 'daily' && n === 1) return 'Daily';
  if (frequency === 'weekly' && n === 1) return 'Weekly';
  if (frequency === 'weekly' && n === 2) return 'Every 2 weeks';
  if (frequency === 'monthly' && n === 1) return 'Monthly';
  if (frequency === 'yearly' && n === 1) return 'Yearly';
  const unit =
    frequency === 'daily'
      ? n === 1
        ? 'day'
        : 'days'
      : frequency === 'weekly'
        ? n === 1
          ? 'week'
          : 'weeks'
        : frequency === 'monthly'
          ? n === 1
            ? 'month'
            : 'months'
          : n === 1
            ? 'year'
            : 'years';
  return `Every ${n} ${unit}`;
}
